module.exports = __webpack_public_path__ + "img/restore-icon.258da27d.svg";